import { DashboardModal } from "dashboard/Dashboard";
import Dropdown from "_shared/components/Dropdown/Dropdown";
import styles from "./TabMenu.module.scss";

interface Props {
  setOpenModal: (modal: DashboardModal) => void;
}

function TabMenu({ setOpenModal }: Props) {
  return (
    <Dropdown>
      <Dropdown.Trigger className="guidedTour2">
        <button className={styles.button} data-test-id="dashboard-menu-addtab">
          <i className="fas fa-plus" />
        </button>
      </Dropdown.Trigger>

      <Dropdown.Content>
        <Dropdown.Item onClick={() => setOpenModal("longbowTabs")}>
          <i className="fas">
            <img
              src="/longbow_tabs.svg"
              style={{ height: 28, marginLeft: -7 }}
              alt="Longbow Logo"
            />
          </i>
          Longbow Tabs
        </Dropdown.Item>
        <Dropdown.Item onClick={() => setOpenModal("customTabs")}>
          <i className="fas">
            <img
              src="/market_insights_tab.svg"
              style={{ height: 28, marginLeft: -7 }}
              alt="Custom tabs"
            />
          </i>
          My Tabs
        </Dropdown.Item>
        <Dropdown.Item onClick={() => setOpenModal("createTab")}>
          <i className="fas fa-plus" />
          Create a new tab
        </Dropdown.Item>
      </Dropdown.Content>
    </Dropdown>
  );
}

export default TabMenu;
